export function filterShapesByInput(data, input) {
  if (!Array.isArray(data) || !input || input.length !== 16) {
    return [];
  }

  return input
    .split("")
    .map((char) => data.find((item) => item.code === char))
    .filter(Boolean); // حذف آیتم‌های پیدا نشده (undefined)
}
